// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_VVt","option":"styles_option__1pHBE","active":"styles_active__3R5Cf"};